import { render } from "./PersonasList.vue?vue&type=template&id=15a29a6a"
import script from "./PersonasList.vue?vue&type=script&lang=js"
export * from "./PersonasList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__